export const capitalizeFirst = str => {
  return str.charAt(0).toUpperCase() + str.slice(1)
} 

export const capitalizeAll = str => {
  return str.split(' ').map(s => capitalizeFirst(s)).join(' ')
}

export const formatNumber = num => {
  num = num.toLocaleString().replace(/,/g, '.')
  return num
}